import styled from "styled-components";
export const IconCopy = styled.i`
  display: inline-block;
  cursor: pointer;
`
export const IconImg = styled.img`
  width: 20px;
`